import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './labeled-info-list.module.less';
import { useUniqueHtmlId } from '../../../hooks/use-unique-html-id';
import { ChildrenPropType } from '../../../prop-types/children';
import { FormattedMessagePropType } from '../../../prop-types/intl';

// NOTE: Must be used as child components within the <LabeledInfoList> component
export const LabeledInfo = ({ children = '', childrenClassName = '', label, labelClassName = '', showMdash = false }) => {
  const id = useUniqueHtmlId('labeled-info');
  return (
    <div>
      <dt className={classnames(style.label, labelClassName)} id={id}>
        {label}
      </dt>
      {showMdash ? (
        <dd aria-details='No Value' aria-labelledby={id} className={classnames(style.info, childrenClassName)}>
          &mdash;
        </dd>
      ) : (
        <dd aria-labelledby={id} className={classnames(style.info, childrenClassName)}>
          {children}
        </dd>
      )}
    </div>
  );
};

LabeledInfo.propTypes = {
  children: ChildrenPropType,
  childrenClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, FormattedMessagePropType]).isRequired,
  labelClassName: PropTypes.string,
  showMdash: PropTypes.bool,
};
